import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';
import { loadingMiddleware } from '../middleware/loadingMiddleware';
const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false, // Disable serialization checks if needed
        }).concat(loadingMiddleware),
});

export default store;